var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"timeline"},[_c('div',{staticClass:"big-intervals",style:({
      backgroundSize: `${_setup.incrementWidth}% 100%`
    })}),_c('div',{staticClass:"small-intervals",style:({
      backgroundSize: `${_setup.incrementWidth / 2}% 100%`
    })}),_vm._l((_setup.delimeters),function(time,index){return _c('div',{key:index,staticClass:"delimeter",style:({ width: _setup.delimeterWidth })},[_vm._v(" "+_vm._s(_setup.formatTime(time))+" ")])}),(_setup.showRemaindingTime)?_c('div',{staticClass:"delimeter"},[_vm._v(" "+_vm._s(_setup.formatTime(_setup.delimeters.length * _setup.delimeter))+" ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }